/**
 * The words the outline card, the program card and the composer share: the scheduling mode with its
 * start day (R54), and what a running turn's step is doing. `t` arrives as a parameter.
 */

import type { TFunction } from 'i18next';

import type { AiSchedulingMode, LiveStep } from '~/entities/ai-conversation';

/** „z datami w kalendarzu · startuje w poniedziałek" or „we własnym tempie" (R54). */
export function schedulingWords(t: TFunction, mode: AiSchedulingMode, startWeekday: number | null): string[] {
  if (mode === 'selfPaced') return [t('web:aiPlan.mode.selfPaced')];
  const words = [t('web:aiPlan.mode.dateBased')];
  if (startWeekday !== null && startWeekday >= 1 && startWeekday <= 7) {
    words.push(t('web:aiPlan.startsOnWeekday', { day: t(`web:aiPlan.reset.weekday.${String(startWeekday)}`) }));
  }
  return words;
}

/** The step codes a running turn reports (`AiTurnResponse.Step`), each with its own words. */
const STEPS: ReadonlySet<string> = new Set(['gate', 'clarify', 'outline', 'catalogue', 'draft', 'repair', 'check', 'answer', 'propose']);

/**
 * The live line of a running turn, in the composer and beside Buddy's mark: a known step code in its
 * own words, else the server's newest line for a step this build does not know, else „working".
 */
export function liveStepWords(t: TFunction, live: LiveStep | null): string {
  const step = live?.step ?? null;
  if (step !== null && STEPS.has(step)) return t(`web:aiPlan.step.${step}`);
  return live?.line ?? t('web:aiPlan.composer.working');
}

/** The facts joined the way both cards draw them. */
export const FACT_SEPARATOR = ' · ';
